import { useMemo, useRef, useState, useCallback, useEffect } from "react";
import "./KolsCarousel.css";

const VIDEOS = [
  {
    id: "CWMQIn4MuA0",
    name: "Hot tiktoker cậu quốc dân Đỗ Hoàn",
    caption: "Tin tưởng và lựa chọn bỉm Rumi cho cháu yêu",
  },
  {
    id: "2c3xiaPBrOc",
    name: " Mẹ Nguyễn Linh",
    caption: "Món quà tuyệt vời từ sếp cũ cho bé yêu nhà tôi",
  },
  // {
  //   id: "aqz-KE-bpKQ",
  //   name: "KOC Mẹ Bé Bơ",
  //   caption: "Lựa chọn hoàn hảo cho mẹ & bé",
  // },
  // {
  //   id: "dQw4w9WgXcQ",
  //   name: "Mom Reviewer",
  //   caption: "Trải nghiệm thấm hút & êm ái",
  // },
  // {
  //   id: "9bZkp7q19f0",
  //   name: "Family Vlog",
  //   caption: "Vận động thoải mái cả ngày",
  // },
];

export default function KolsCarousel() {
  const trackRef = useRef(null);
  const cardRefs = useRef({});
  const [playing, setPlaying] = useState({}); // {videoId: true}
  const [visible, setVisible] = useState({}); // {videoId: true if in viewport}
  const [navForceVisible, setNavForceVisible] = useState(false);
  const hideTimerRef = useRef(null);

  // card đang phát & đang nằm trong viewport?
  const anyPlayingVisible = useMemo(
    () => Object.keys(playing).some((id) => playing[id] && visible[id]),
    [playing, visible]
  );

  // Ẩn nút khi đang phát & card hiện trong viewport, trừ khi người dùng vừa tương tác (navForceVisible)
  const hideNav = anyPlayingVisible && !navForceVisible;

  // Quan sát card trong viewport
  useEffect(() => {
    const root = trackRef.current;
    if (!root) return;
    const io = new IntersectionObserver(
      (entries) => {
        setVisible((prev) => {
          const next = { ...prev };
          entries.forEach((e) => {
            const id = e.target.getAttribute("data-videoid");
            if (id) next[id] = e.isIntersecting && e.intersectionRatio >= 0.6;
          });
          return next;
        });
      },
      { root, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
    );
    Object.values(cardRefs.current).forEach((el) => el && io.observe(el));
    return () => io.disconnect();
  }, []);

  // Hiện nút tạm thời khi người dùng tương tác ở đâu cũng được
  useEffect(() => {
    const showNavTemporarily = () => {
      // nếu không có video nào đang phát trong viewport thì không cần show
      if (!anyPlayingVisible) return;
      setNavForceVisible(true);
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = setTimeout(() => setNavForceVisible(false), 2000); // 2s rồi ẩn lại nếu vẫn đang phát
    };
    const evts = ["click", "touchstart", "mousemove", "keydown", "wheel"];
    evts.forEach((t) =>
      document.addEventListener(t, showNavTemporarily, { passive: true })
    );
    return () => {
      evts.forEach((t) => document.removeEventListener(t, showNavTemporarily));
      clearTimeout(hideTimerRef.current);
    };
  }, [anyPlayingVisible]);

  // Nếu không còn video phát → đảm bảo nút hiện
  useEffect(() => {
    if (!anyPlayingVisible) {
      setNavForceVisible(false);
      clearTimeout(hideTimerRef.current);
    }
  }, [anyPlayingVisible]);

  const scrollByCards = useCallback((dir) => {
    const track = trackRef.current;
    if (!track) return;
    const firstCard = track.querySelector(".kols-card");
    if (!firstCard) return;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || "0");
    const delta = dir * (cardWidth + gap);
    track.scrollBy({ left: delta, behavior: "smooth" });
  }, []);

  return (
    <section className="kols-wrap">
      <h2 className="kols-title">TRẢI NGHIỆM CỦA KOLS/KOCS & NGƯỜI DÙNG</h2>
      <p className="kols-sub">
        Những chia sẻ chân thật về chất lượng & trải nghiệm sử dụng
      </p>

      <div className="kols-carousel">
        <button
          className={`kols-nav kols-prev ${hideNav ? "is-hidden" : ""}`}
          aria-label="Prev"
          onClick={() => scrollByCards(-1)}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className="kols-viewport">
          <div className="kols-track" ref={trackRef}>
            {VIDEOS.map((v) => {
              const isPlaying = !!playing[v.id];
              return (
                <article
                  className="kols-card"
                  key={v.id}
                  data-videoid={v.id}
                  ref={(el) => (cardRefs.current[v.id] = el)}
                >
                  <div className="kols-media">
                    {isPlaying ? (
                      <iframe
                        src={`https://www.youtube.com/embed/${v.id}?autoplay=1&rel=0`} // (xem phần nâng cao bên dưới)
                        title={v.name}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        loading="lazy"
                      />
                    ) : (
                      <button
                        className="kols-thumb"
                        onClick={() =>
                          setPlaying((s) => ({ ...s, [v.id]: true }))
                        }
                        aria-label={`Xem video ${v.name}`}
                      >
                        <img
                          src={`https://img.youtube.com/vi/${v.id}/hqdefault.jpg`}
                          alt={v.name}
                          loading="lazy"
                        />
                        <span className="kols-play">
                          <svg
                            fill="none"
                            height="100%"
                            viewBox="0 0 87 115"
                            width="100%"
                          >
                            <path
                              clip-rule="evenodd"
                              d="M83.99 10.81C90.08 21.24 86.62 34.66 76.26 40.79L69.05 45.06L74.17 47.38C81.58 50.74 86.52 57.99 86.96 66.17C87.40 74.34 83.27 82.09 76.26 86.24L32.76 111.97C22.41 118.10 9.08 114.61 3.00 104.18C-3.08 93.75 .37 80.33 10.73 74.20L17.94 69.93L12.82 67.61C5.41 64.25 .47 57.00 .03 48.82C-0.40 40.65 3.72 32.90 10.73 28.75L54.23 3.02C64.58 -3.10 77.91 .38 83.99 10.81Z"
                              fill="#f00"
                              fill-rule="evenodd"
                            ></path>
                            <path
                              clip-rule="evenodd"
                              d="M33 74L33 41L61 57.5L33 74Z"
                              fill="white"
                              fill-rule="evenodd"
                            ></path>
                          </svg>
                        </span>
                      </button>
                    )}
                  </div>

                  <div className="kols-meta">
                    <div className="kols-name">{v.name}</div>
                    <div className="kols-caption">{v.caption}</div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>

        <button
          className={`kols-nav kols-next ${hideNav ? "is-hidden" : ""}`}
          aria-label="Next"
          onClick={() => scrollByCards(1)}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  );
}
